module.exports = __webpack_public_path__ + "img/whatsapp.bbfd3636.png";